import { WEB_COMPONENT_MSP_EDR_TRIAL_REPORT } from '../webcomponents.constants';
import { MspEdrTrialReportWebComponent } from './component/MspEdrTrialReportWebComponent';

export { MspEdrTrialReportWebComponent };

window.customElements.define(WEB_COMPONENT_MSP_EDR_TRIAL_REPORT, MspEdrTrialReportWebComponent);